/* Maison Dorian - sticky de paiement (PDP v2, lot S).
 * Contrat : lit l'evenement md:selection-change et window.mdBuy.getSelection() ; n'appelle que window.mdBuy.checkout().
 * Observe #md-buy-cta (IntersectionObserver, y compris dans les shadow roots) : la barre apparait quand il sort de l'ecran.
 * Etat "en cours" immediat au clic ; echec = retour a l'etat precedent + message court + relance.
 * Vrai bouton Shopify (payment_button) : montre seulement si des paiements acceleres de marque existent
 * ET que la selection est un seul produit sans reduction. Sinon bouton "Commander maintenant".
 */
(function () {
  'use strict';
  /* La barre est rendue dans un shadow root (instant-layout) : document.getElementById ne la voit pas,
     et un ancetre transforme la rendait fixed par rapport a lui. On la cherche partout puis on la deplace sous <body>. */
  function rootsOf(r, a) { a.push(r); r.querySelectorAll('*').forEach(function (e) { if (e.shadowRoot) rootsOf(e.shadowRoot, a); }); return a; }
  var bar = null;
  (function () {
    var rs = rootsOf(document, []);
    for (var i = 0; i < rs.length && !bar; i++) bar = rs[i].querySelector('#md-sticky-pay');
  })();
  if (!bar) return;
  if (bar.parentNode !== document.body) {
    var st = bar.previousElementSibling;
    if (st && st.tagName === 'STYLE') document.body.appendChild(st);
    document.body.appendChild(bar);
  }

  var $ = function (s) { return bar.querySelector(s); };
  var elLabel = $('[data-md-sp-label]'), elPot = $('[data-md-sp-pot]');
  var btn = $('[data-md-sp-btn]'), btnT = $('[data-md-sp-btn-t]'), elErr = $('[data-md-sp-err]');
  var wallet = $('[data-md-sp-wallet]');
  var unit = parseInt(bar.getAttribute('data-unit-price'), 10) || 0;
  var IDLE = 'Commander maintenant';
  var sel = null, ctaVisible = true, ctaKnown = false, busy = false, busyTimer = 0, lastY = 0;

  function eur(cents) {
    var v = (cents || 0) / 100;
    var s = (Math.round(v * 100) % 100 === 0) ? String(Math.round(v)) : v.toFixed(2).replace('.', ',');
    return s + ' €';
  }

  function readSel() {
    try { if (window.mdBuy && window.mdBuy.getSelection) return window.mdBuy.getSelection(); } catch (e) {}
    return null;
  }

  /* ---- affichage de la selection ---- */
  function render() {
    if (!sel) return;
    if (sel.label) elLabel.textContent = String(sel.label).split(' · ')[0];
    var n = 0, i;
    if (sel.items) for (i = 0; i < sel.items.length; i++) n += sel.items[i].qty || 1;
    var pp = typeof sel.perPot === 'number' ? sel.perPot : (n && typeof sel.total === 'number' ? Math.round(sel.total / n) : null);
    if (pp !== null) elPot.textContent = eur(pp);
    syncWallet();
  }

  function onSel(e) {
    sel = (e && e.detail) || readSel();
    render();
  }
  document.addEventListener('md:selection-change', onSel);

  /* ---- boutons acceleres du panier (Apple Pay, Shop Pay, Google Pay) ----
     Le panier est rempli en arriere-plan avec la selection ; les boutons Shopify paient ce panier.
     Pendant la synchronisation les boutons sont attenues et non cliquables (data-wallet=sync). */
  var canApple = false;
  try { canApple = !!(window.ApplePaySession && window.ApplePaySession.canMakePayments()); } catch (e) {}
  /* Les boutons Shopify (et le SDK PayPal ~100 Ko) ne sont instancies que si Apple Pay est dispo : le HTML est inerte dans <template> */
  if (wallet && canApple) {
    try { var wtpl = wallet.querySelector('template[data-md-sp-tpl]'); if (wtpl) wallet.appendChild(wtpl.content.cloneNode(true)); } catch (e) {}
  }
  var hasWallet = !!wallet && canApple;
  var syncSeq = 0, syncTimer = 0, syncedKey = '';
  function selKey() {
    if (!sel || !sel.items || !sel.items.length) return '';
    return sel.items.map(function (i) { return i.id + ':' + (i.qty || 1); }).join(',');
  }
  function jpost(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r; });
  }
  /* Le composant Shopify lit l'identifiant du panier au rendu serveur : pour un visiteur sans panier il est vide.
     Apres le premier remplissage on recharge le composant a partir d'une page fraiche (une seule fois). */
  var refreshed = false;
  function refreshWallet() {
    if (refreshed) return Promise.resolve();
    refreshed = true;
    return fetch(window.location.pathname + window.location.search, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var m = html.match(/<shopify-accelerated-checkout-cart[\s\S]*?<\/shopify-accelerated-checkout-cart>/);
        var cur = wallet.querySelector('shopify-accelerated-checkout-cart');
        if (!m || !cur) return;
        var tpl = document.createElement('template'); tpl.innerHTML = m[0];
        var el = tpl.content.firstElementChild, cfg = [];
        try { cfg = JSON.parse(el.getAttribute('wallet-configs')).filter(function (w) { return w.name === 'apple_pay'; }); } catch (e) {}
        if (!cfg.length) { hasWallet = false; return; }
        el.setAttribute('wallet-configs', JSON.stringify(cfg));
        cur.replaceWith(el);
      })
      .catch(function () {});
  }
  function syncCart() {
    if (!hasWallet) return;
    var key = selKey();
    if (!key) { bar.setAttribute('data-wallet', 'off'); return; }
    if (key === syncedKey) { bar.setAttribute('data-wallet', 'on'); return; }
    var seq = ++syncSeq;
    bar.setAttribute('data-wallet', 'sync');
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      var items = sel.items.map(function (i) { return { id: i.id, quantity: i.qty || 1 }; });
      var Q = window.mdCartQ = window.mdCartQ || function (fn) { var p = (window.__mdCartTail || Promise.resolve()).then(fn); window.__mdCartTail = p.catch(function () {}); return p; };
      Q(function () { return jpost('/cart/clear.js', {}).then(function () { return jpost('/cart/add.js', { items: items }); }); })
        .then(function () { return refreshWallet(); })
        .then(function () {
          if (seq !== syncSeq) return;
          syncedKey = key;
          bar.setAttribute('data-wallet', hasWallet ? 'on' : 'off');
        })
        .catch(function () { if (seq === syncSeq) { syncedKey = ''; bar.setAttribute('data-wallet', 'off'); } });
    }, 350);
  }
  function syncWallet() { if (bar.getAttribute('data-state') === 'shown') syncCart(); }

  /* ---- etat occupe / erreur ---- */
  function setBusy(on) {
    busy = on;
    btn.setAttribute('data-busy', on ? 'true' : 'false');
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
    btnT.textContent = on ? 'Redirection…' : IDLE;
    clearTimeout(busyTimer);
    if (on) busyTimer = setTimeout(function () { fail(); }, 12000);
  }
  function fail() {
    setBusy(false);
    btnT.textContent = 'Réessayer';
    bar.setAttribute('data-error', 'true');
  }
  function clearErr() { bar.setAttribute('data-error', 'false'); }

  function fallbackCheckout() {
    var s = sel || readSel();
    if (s && s.items && s.items.length) {
      var parts = s.items.map(function (i) { return i.id + ':' + (i.qty || 1); });
      window.location.href = '/cart/' + parts.join(',');
      return true;
    }
    return false;
  }

  btn.addEventListener('click', function () {
    if (busy) return;
    clearErr();
    setBusy(true); /* retour visuel immediat, avant toute reponse reseau */
    if (window.mdBuy && typeof window.mdBuy.checkout === 'function') {
      var p;
      try { p = Promise.resolve(window.mdBuy.checkout()); } catch (e) { p = Promise.reject(e); }
      p.then(function (ok) { if (ok === false) fail(); }, function () { fail(); });
      return;
    }
    /* repli propre : lot B absent */
    if (!fallbackCheckout()) {
      setBusy(false);
      var cta = findCta();
      if (cta && cta.scrollIntoView) cta.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  /* retour arriere depuis le checkout (bfcache) : on remet le bouton a l'etat initial */
  window.addEventListener('pageshow', function (e) { if (e.persisted) { setBusy(false); clearErr(); } });

  /* ---- visibilite : #md-buy-cta hors ecran ---- */
  function roots(r, a) {
    a.push(r);
    r.querySelectorAll('*').forEach(function (e) { if (e.shadowRoot) roots(e.shadowRoot, a); });
    return a;
  }
  function findCta() {
    var rs = roots(document, []);
    for (var i = 0; i < rs.length; i++) { var e = rs[i].querySelector('#md-buy-cta'); if (e) return e; }
    return null;
  }

  function show(on) {
    var cur = bar.getAttribute('data-state') === 'shown';
    if (on === cur) return;
    bar.setAttribute('data-state', on ? 'shown' : 'hidden');
    if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    document.body.style.paddingBottom = on ? (bar.offsetHeight + 'px') : '';
    if (on) syncCart();
  }
  function update() {
    if (ctaKnown) { show(!ctaVisible); return; }
    show((window.scrollY || 0) > 600); /* repli : CTA introuvable */
  }

  var io = null, watched = null;
  function watch(cta) {
    if (watched === cta) return;
    watched = cta;
    if (io) io.disconnect();
    if (!('IntersectionObserver' in window)) { ctaKnown = false; return; }
    io = new IntersectionObserver(function (entries) {
      var en = entries[entries.length - 1];
      var r = en.boundingClientRect;
      if (!r.width && !r.height) { ctaKnown = true; ctaVisible = true; } /* masque : pas de barre */
      else { ctaKnown = true; ctaVisible = en.isIntersecting; }
      update();
    }, { threshold: 0.05 });
    io.observe(cta);
  }

  var tries = 0;
  function seek() {
    var c = findCta();
    if (c) { watch(c); return true; }
    return false;
  }
  if (!seek()) {
    var t = setInterval(function () { if (seek() || ++tries > 40) clearInterval(t); }, 500);
  }
  /* le bloc d'achat peut etre reconstruit : on re-resout la cible au rechargement de la fenetre */
  window.addEventListener('load', function () { seek(); update(); });
  window.addEventListener('scroll', function () {
    var y = window.scrollY || 0;
    if (!ctaKnown && Math.abs(y - lastY) > 40) { lastY = y; update(); }
  }, { passive: true });
  window.addEventListener('resize', function () {
    if (bar.getAttribute('data-state') === 'shown') document.body.style.paddingBottom = bar.offsetHeight + 'px';
  });

  /* ---- init ---- */
  sel = readSel();
  render();
  update();
})();
